const btnConfirmDialog = {
  cancel: 'CANCEL',
  ok: 'OK'
};

export default btnConfirmDialog;
